import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { httpConstants } from './http-constants';

@Injectable({ providedIn: 'root' })
export class HttpTranslations {
    constructor(private tranlateService: TranslateService) {
    }
    successfullySaved = this.tranlateService.get(`${httpConstants.translationGroup}.SuccessfullySaved`);
    successfullyDeleted = this.tranlateService.get(`${httpConstants.translationGroup}.SuccessfullyDeleted`);

}